/**
 * ListSelect 公共页面
 * @author xiaohuangmaoth
 * @date 2020-01-11
 */
import React from "react";
import PropTypes from "prop-types";
import { connect } from "dva";
import { modelUtils, Storage, jsonToString } from "@/utils";
import { Spin } from "antd";
import { utils_tool, component_tool, framework_tool } from "@/tool";
const {
  WizCard,
  WizSearchBar,
  WizDataTable,
  WizButton,
  WizModalForm,
  WizAlert,
  WizModalTable,
  WizListSelect,
  WizRow,
  WizCol
} = component_tool;
const { WizContainer } = framework_tool;
const { getPageData } = utils_tool;

class ListSelect extends WizContainer {
  componentName = "ListSelect";

  constructor(props) {
    super(props);
    this.state = {
      record: null,
      rows: []
    };
  }

  static propTypes = {
    defaultSearch: PropTypes.bool,
    selectedRows: PropTypes.array,
    tableApi: PropTypes.object,
    tableProps: PropTypes.object
  };

  static defaultProps = {
    defaultSearch: true
  };

  _componentDidMount = () => {
    if (this.props.defaultSearch) {
      this._getData(this.props.tableApi);
    }
  };

  _getData(tableApi, values, other = {}) {
    const { path, apiParams } = tableApi;
    const [name, key] = path.split("/");
    this.doAction({
      path,
      payload: {
        key,
        apiParams: { ...apiParams, ...values, ...other }
      }
    });
  }

  _render() {
    const {
      table,
      tableLoading,
      tableProps,
      listProps,
      selectedRows,
      tableApi,
      key
    } = this.props;
    const { record, rows } = this.state;
    const dataItems = getPageData(table.data);
    const searchBarProps = {
      columns: tableProps.columns,
      onSearch: values => {
        this.filters = values || {}
        this.setState(() => {
          this._getData(tableApi, values);
        });
      }
    };

    const dataTableProps = {
      loading: tableLoading,
      dataItems,
      onChange: ({ pageNum, pageSize }) => {
        this._getData(tableApi, { current: pageNum, size: pageSize },this.filters);
      },
      selectedRowKeys: selectedRows.map(item => item.rowKey),
      ...tableProps
    };

    const listSelectProps = {
      rows: selectedRows,
      ...listProps
    };

    const isCheckbox = tableProps.selectType === "checkbox";

    return (
      <WizRow key={key || 'listSelect'}>
        <WizCol span={isCheckbox ? 16 : 24}>
          <WizCard>
            <WizSearchBar
              type="grid"
              {...searchBarProps}
              cols={{ xs: 14, md: 12, xl: 10 }}
              style={{ marginBottom: 15}}
            />
            <WizDataTable {...dataTableProps} />
            <div className="pagination">
              <WizDataTable.Pagination {...dataTableProps} />
            </div>
          </WizCard>
        </WizCol>
        {isCheckbox ? (
          <WizCol span={8}>
            <WizListSelect {...listSelectProps} />
          </WizCol>
        ) : null}
      </WizRow>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { path } = ownProps.tableApi;
  const [name, key] = path.split("/");
  const table = modelUtils.getModelEntity(state[name], key);
  const load = modelUtils.getLoadingState(state, name);
  return {
    table,
    ...load
  };
};

export default connect(mapStateToProps)(ListSelect);
